(() => {
  function init(root) {
    root.sunnyAbort?.abort();
    root.sunnyAbort = new AbortController();
    const signal = root.sunnyAbort.signal;
    const $ = s => root.querySelector(s);
    const $$ = s => [...root.querySelectorAll(s)];
    const base = root.dataset.root || '/';
    const form = $('#SunnyProductForm');
    const drawer = $('.drawer');
    const sticky = $('.stickybuy');
    const mainBuy = form?.querySelector('button[type="submit"]');
    const error = $('.form-error');
    let returnFocus, busy = false, cartBusy = false;
    const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'tr', {style:'currency',currency:root.dataset.currency || 'TRY'}).format(amount / 100);
    const node = (tag, text, cls) => {const n = document.createElement(tag); if (text != null) n.textContent = text; if (cls) n.className = cls; return n;};
    const report = message => {if(error){error.textContent = message;error.hidden = !message;}};
    async function api(path, payload) {
      const response = await fetch(base + path, {credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, ...(payload ? {method:'POST',body:JSON.stringify(payload)} : {})});
      let data;
      try {data = await response.json();}
      catch {throw new Error('Mağazaya ulaşılamadı. Lütfen tekrar deneyin veya sepet sayfasını açın.');}
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : 'İşlem tamamlanamadı. Lütfen tekrar deneyin.');
      return data;
    }
    let stickyFrame = 0;
    function updateSticky() {
      if (!sticky) return;
      // Below the purchase area only: being outside the viewport below does not count.
      const passed = mainBuy && mainBuy.getBoundingClientRect().bottom <= 0;
      sticky.hidden = !(passed && window.matchMedia('(max-width: 760px)').matches && drawer.hidden);
    }
    function scheduleSticky() {
      if (!stickyFrame) stickyFrame = requestAnimationFrame(() => {stickyFrame = 0;updateSticky();});
    }
    if (sticky && mainBuy) {
      window.addEventListener('scroll', scheduleSticky, {passive:true,signal});
      window.addEventListener('resize', scheduleSticky, {passive:true,signal});
      window.addEventListener('pageshow', scheduleSticky, {signal});
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(updateSticky) : null;
      observer?.observe(mainBuy);
      const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(scheduleSticky) : null;
      resizeObserver?.observe(root);
      signal.addEventListener('abort', () => {observer?.disconnect();resizeObserver?.disconnect();cancelAnimationFrame(stickyFrame);}, {once:true});
      updateSticky();
    }
    function closeCart() {
      drawer.hidden = true; $('.backdrop').hidden = true;
      document.body.style.overflow = '';
      updateSticky(); returnFocus?.focus();
    }
    function showCart() {
      returnFocus = document.activeElement;
      drawer.hidden = false; $('.backdrop').hidden = false;
      if($('.stickybuy')) $('.stickybuy').hidden = true;
      document.body.style.overflow = 'hidden'; $('.drawer .close').focus();
    }
    function cartError(message) {const p = node('p',message,'form-error');p.setAttribute('role','alert');$('#cartcontent').append(p);}
    async function changeLine(key, quantity) {
      if(cartBusy) return;
      cartBusy = true;
      $$('#cartcontent button').forEach(b => b.disabled = true);
      try {renderCart(await api('cart/change.js',{id:key,quantity}));}
      catch(e) {try {renderCart(await api('cart.js'));} catch {} cartError(e.message);}
      finally {cartBusy = false;}
    }
    function renderCart(cart) {
      $('#cartcount').textContent = cart.item_count;
      const content = $('#cartcontent'); content.replaceChildren();
      if (!cart.items.length) {content.append(node('p','Sepetin henüz boş. Kendine sıcacık bir set seç.'));return;}
      cart.items.forEach(item => {
        const row = node('div',null,'cartline');
        if(item.image){const image=node('img');image.src=item.image;image.alt=item.product_title;row.append(image);}
        const info=node('div'); const link=node('a',item.product_title);link.href=item.url;const strong=node('strong');strong.append(link);info.append(strong);
        if(item.variant_title) info.append(node('p',item.variant_title));
        info.append(node('p',money(item.final_line_price)));
        (item.line_level_discount_allocations || []).forEach(d => info.append(node('p',d.discount_application.title)));
        const remove=node('button','Kaldır','remove');remove.type='button';remove.onclick=()=>changeLine(item.key,0);info.append(remove);
        const controls=node('div',null,'cart-actions');
        const minus=node('button','−');minus.type='button';minus.setAttribute('aria-label',item.product_title+' paket adedini azalt');minus.onclick=()=>changeLine(item.key,item.quantity-1);
        const plus=node('button','+');plus.type='button';plus.setAttribute('aria-label',item.product_title+' paket adedini artır');plus.onclick=()=>changeLine(item.key,item.quantity+1);
        controls.append(minus,node('output',item.quantity+' paket'),plus);info.append(controls);row.append(info);content.append(row);
      });
      const total=node('div',null,'total');total.append(node('span','Toplam'),node('span',money(cart.total_price)));content.append(total);
      const checkout=node('form');checkout.action=base+'cart';checkout.method='post';
      const button=node('button','Güvenli ödemeye geç →','btn');button.type='submit';button.name='checkout';checkout.append(button);content.append(checkout);
      const cartLink=node('a','Sepeti görüntüle','outline');cartLink.href=base+'cart';cartLink.style.cssText='display:block;text-align:center;margin-top:12px';content.append(cartLink);
      content.append(node('p','Kargo ve varsa ek indirimler ödeme adımında hesaplanır.','helper'));
    }
    $('.cartbtn').onclick = async () => {
      $('#cartcontent').replaceChildren(node('p','Sepet yükleniyor…'));showCart();
      try {renderCart(await api('cart.js'));}catch(e){cartError(e.message);const a=node('a','Sepeti aç','outline');a.href=base+'cart';$('#cartcontent').append(a);}
    };
    $('.drawer .close').onclick=closeCart;$('.backdrop').onclick=closeCart;
    root.addEventListener('keydown', e => {
      if(drawer.hidden) return;
      if(e.key==='Escape') closeCart();
      if(e.key==='Tab') {const nodes=[...drawer.querySelectorAll('button:not(:disabled),a[href],input:not(:disabled)')].filter(n=>n.getClientRects().length);const first=nodes[0],last=nodes.at(-1);if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}}
    }, {signal});
    form?.addEventListener('submit',async e=>{
      e.preventDefault();if(busy) return;
      const selected=form.querySelector('[name="id"]:checked');if(!selected){report('Lütfen stokta olan bir paket seçin.');return;}
      busy=true;report('');const buttons=$$('button[form="SunnyProductForm"],#SunnyProductForm button[type="submit"]');buttons.forEach(b=>{b.disabled=true;b.setAttribute('aria-busy','true');});
      try {
        await api('cart/add.js',{items:[{id:Number(selected.value),quantity:1}]});
        // A cart refresh failure must not suggest adding the same item a second time.
        try {renderCart(await api('cart.js'));showCart();}
        catch {window.location.assign(base+'cart');}
      }catch(e){report(e.message);}
      finally{busy=false;buttons.forEach(b=>{b.disabled=false;b.removeAttribute('aria-busy');});}
    }, {signal});
    $$('[name="id"]').forEach(r=>r.addEventListener('change',()=>{
      $('#topprice').textContent=r.dataset.price;
      $$('[data-selected-price]').forEach(n=>n.textContent=r.dataset.price);
      report('');
      if(location.pathname.includes('/products/')){const url=new URL(location.href);url.searchParams.set('variant',r.value);history.replaceState({},'',url);}
    }, {signal}));
    $$('.thumb').forEach(t=>t.onclick=()=>{
      $$('.thumb').forEach(b=>{b.classList.toggle('active',b===t);b.setAttribute('aria-pressed',String(b===t));});
      $('.stage').dataset.view=t.dataset.view;
      $('#mainphoto').src=t.querySelector('img').src;$('#mainphoto').alt=t.querySelector('img').alt;
      $('#lightbox img').src=$('#mainphoto').src;
      $('#photocaption').textContent=t.dataset.caption || {set:'Koala peluş kemer + sıcak su torbası · Stüdyo görselleştirmesi',detail:'Peluş yüzey ve koala yüz detayı',bottle:'Pembe sıcak su torbası detayı',standing:'Gününe eşlik eden, eller serbest kemer tasarımı',home:'Evde, kendi ritminde sıcacık bir mola'}[t.dataset.view];
    });
    if($('.expand')) $('.expand').onclick=()=>$('#lightbox').showModal();if($('#review')) $('#review').onclick=()=>$('#reviewdialog').showModal();
    $$('dialog').forEach(d=>{d.querySelector('.close').onclick=()=>d.close();d.onclick=e=>{if(e.target===d)d.close();};});
    $('.menu').onclick=()=>{const open=$('.menu').getAttribute('aria-expanded')==='true';$('.menu').setAttribute('aria-expanded',String(!open));$('.mobilelinks').hidden=open;};
    $$('.mobilelinks a').forEach(a=>a.onclick=()=>{$('.mobilelinks').hidden=true;$('.menu').setAttribute('aria-expanded','false');});
    $$('[data-faq]').forEach(b=>b.onclick=()=>{const area=b.closest('section');area.querySelectorAll('[data-faq]').forEach(t=>t.setAttribute('aria-pressed',String(t===b)));area.querySelectorAll('.faq-group').forEach(g=>g.hidden=b.dataset.faq!=='all'&&g.dataset.group!==b.dataset.faq);});
  }
  const load = container => container.querySelectorAll('.sunny-store').forEach(init);
  load(document);
  document.addEventListener('shopify:section:load', e => load(e.target));
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('.sunny-store').forEach(r=>r.sunnyAbort?.abort()));
  document.addEventListener('shopify:block:select', e => {const block=e.target;if(block.matches('.thumb'))block.click();else block.scrollIntoView({block:'center',behavior:'smooth'});});
})();
